module.exports = __webpack_public_path__ + "az.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/az.svg
// module id = 689
// module chunks = 0